import React from 'react'
import { DataRibbon } from '../../Components/DataRibbon/DataRibbon'
import Slider from '../../Components/Slider/Slider'
import { Subjects } from '../../Components/Subjects/Subjects'
import ImportantLinks from '../../Components/Important_links/Important_links'

export const Home = () => {
    return (
        <>
            <Slider />
            <DataRibbon />
            <Subjects />
            <ImportantLinks />
        </>
    )
}
